<div class="dialog-container">
  <h2 mat-dialog-title>{{ isEdit ? 'Edit Suggestion' : 'Add new Suggestion' }}</h2>
  
  <form [formGroup]="form" (ngSubmit)="onSave()">
    <mat-dialog-content>
      <div class="form-fields">
        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Suggestion Tag</mat-label>
          <input matInput formControlName="tag" placeholder="Enter suggestion tag" (input)="onTagInput($event)">
          <mat-hint>This is how you will refer to the suggestion in the script</mat-hint>
          <mat-error *ngIf="form.get('tag')?.hasError('required')">
            Suggestion tag is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Suggestion Prompt</mat-label>
          <input matInput formControlName="description" placeholder="Enter suggestion prompt">
          <mat-hint>This prompt will be shown to the audience member</mat-hint>
          <mat-error *ngIf="form.get('description')?.hasError('required')">
            Suggestion prompt is required
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" style="width: 100%;">
          <mat-label>Examples</mat-label>
          <input matInput formControlName="examples" placeholder="Enter examples separated by commas">
          <mat-hint>List of examples for the "Suggest for me" button</mat-hint>
          <mat-error *ngIf="form.get('examples')?.hasError('required')">
            Examples are required
          </mat-error>
        </mat-form-field>
      </div>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      @if (isEdit) {
        <button mat-button type="button" color="warn" (click)="onDelete()">Delete</button>
      }
      <button mat-button type="button" (click)="onCancel()">Cancel</button>
      <button mat-raised-button  type="submit" [disabled]="!form.valid">
        {{ isEdit ? 'Apply Changes' : 'Add Suggestion' }}
      </button>
    </mat-dialog-actions>
  </form>
</div>
